import { K1Information } from '@e3dc-react/icons'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import React from 'react'
import { HIDE_ON_PRINT_CLASS } from '../../shared/utils/print-chart-data'

interface Props {
  text: string
}

/*
 * This component renders the pie chart tooltip
 */
const PieChartTooltip: React.FC<Props> = ({ text }) => {
  return (
    <OptionalTooltipWrapper sx={{ alignItems: 'flex-end', cursor: 'pointer' }} titleKey={text} hideOnPrintClass={HIDE_ON_PRINT_CLASS}>
      <K1Information />
    </OptionalTooltipWrapper>
  )
}

export default PieChartTooltip
